import type {
	AdvancedPageTemplateContentItem,
	CampaignConfigContentITem,
	PageConfigContentItem,
	Tersed,
} from '@/services/kontent-ai/types'

export function handleUTMQueryItem(
	item: string | string[] | undefined
): string | undefined {
	if (typeof item === 'string') {
		return item
	}
	if (Array.isArray(item)) {
		return item[0]
	}
	return ''
}

function isCampaignConfig(
	pageConfig: Tersed<PageConfigContentItem>
): pageConfig is Tersed<CampaignConfigContentITem> {
	return 'campaignId' in pageConfig.elements
}

export function resolveCampaignIdFromPage(
	page: Tersed<AdvancedPageTemplateContentItem>
): string | null {
	const pageConfig = page.elements.config[0]
	if (!pageConfig || !isCampaignConfig(pageConfig)) {
		return null
	}

	const campaignId = pageConfig.elements.campaignId
	return typeof campaignId === 'string' && campaignId.length > 0
		? campaignId
		: null
}
